import React, { SVGProps } from 'react';

/**
 * Resync icon for the Dynamics 365 integration.
 *
 * Mirrors the design-system Resync*SmIcon contract (16x16 viewBox, the brand
 * mark centred on (8,8), currentColor fill/stroke) so it behaves
 * identically to its siblings returned by getResyncIconForIntegrationType.
 */
const ResyncDynamicsIcon = ({
  className,
  ...props
}: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 16 16"
      className={['size-6', className].filter(Boolean).join(' ')}
      {...props}
    >
      {/*
        Dynamics mark: the two ribbons of the logo, flat, scaled to an 8 high
        footprint and centred on (8,8).
      */}
      <g transform="translate(4.667 4) scale(0.2222)">
        <path
          fill="currentColor"
          d="M0 3.24301C0 0.556995 1.79738 -0.11517 3.75053 0.0153116C17.6097 0.941235 30 5.04795 30 10.3228V26.5735C30 24.051 27.4524 21.9417 23.5047 20.2893C22.9058 20.0386 22.5014 19.4607 22.5014 18.8115V13.5044C22.5014 10.4674 21.2274 9.1941 18.7515 8.48636C16.2755 7.77863 14.9984 8.56286 14.9984 11.3524V14.0135C14.9984 15.8832 13.779 17.1139 11.6291 17.465C9.4791 17.8161 7.65405 18.0245 4.87781 18.2755C2.10154 18.5265 0 16.7421 0 13.7213V3.24301Z"
        />
        <path
          fill="currentColor"
          d="M29.9996 10.3236C29.9996 14.6488 22.0596 18.012 11.9996 19.6721C9.46772 20.0899 7.49961 21.2743 7.49961 23.9176V31.9892C7.49961 35.8174 9.80346 36.3215 12.7488 35.8174C23.3225 34.0077 29.9996 30.2903 29.9996 26.5608V10.3236Z"
        />
      </g>
    </svg>
  );
};

export default ResyncDynamicsIcon;
